if (window.__modalJsLoaded) {
} else {
window.__modalJsLoaded = true;
window.modal = {
  init: function () {
    // Move modals outside of .transition-body to fix position:fixed issues
    // (.transition-body has transform which creates a containing block)
    this.moveModalsToContainer();

    // closing through overlay click
    document.querySelectorAll(".modal-overlay").forEach(function (el) {
      el.addEventListener("click", function (e) {
        if (e.target.closest(".modal")) {
          return;
        }
        this.classList.remove("show-modal");
      });
    });

    // closing through close button click
    document
      .querySelectorAll(".modal-close, .modal-close-button")
      .forEach(function (el) {
        el.addEventListener("click", function () {
          this.closest(".modal-overlay").classList.remove("show-modal");
        });
      });

    // selecting an offer
    document
      .querySelectorAll(".modal .offers button")
      .forEach(function (clickedOfferButton) {
        clickedOfferButton.addEventListener("click", function () {
          this.closest(".offers")
            .querySelectorAll("button")
            .forEach(function (offerButton) {
              offerButton.classList.remove("selected");
            });
          this.classList.add("selected");
          // also, if in gift modal - activate the submit button
          this.closest(".gift-modal")
            ?.querySelector(".button")
            .classList.add("active");
        });
      });

    // month toggle
    document.querySelectorAll(".month-toggle p").forEach(function (toggle) {
      const giftInfoModal = toggle.closest(".gift-info-modal");
      const isLower = toggle.classList.contains("three");
      toggle.addEventListener("click", function () {
        giftInfoModal
          .querySelectorAll(".modal-header")
          .forEach(function (modalHeader) {
            if (
              (modalHeader.classList.contains("modal-header-lower") &&
                isLower) ||
              (modalHeader.classList.contains("modal-header-higher") &&
                !isLower)
            ) {
              modalHeader.style.display = "block";
            } else {
              modalHeader.style.display = "none";
            }
          });
        giftInfoModal
          .querySelector(".month-toggle .three")
          .classList.toggle("selected", isLower);
        giftInfoModal
          .querySelector(".month-toggle .six")
          .classList.toggle("selected", !isLower);
      });
    });

    // gift modal - submit
    document
      .querySelectorAll(".gift-modal a.button")
      .forEach(function (button) {
        const giftModal = button.closest(".gift-modal");
        button.addEventListener("click", function (e) {
          e.stopPropagation();
          const giftVariantId = giftModal.querySelector(
            ".offers button.selected",
          )?.dataset.gid;
          const cartItemJSON = giftModal.dataset.cartItem;
          if (!giftVariantId || !cartItemJSON) {
            return false;
          }
          const cartItem = JSON.parse(cartItemJSON);
          window.priceSelectorV2.addToCart(cartItem, giftVariantId);
          return false;
        });
      });

    // benefits modal - use event delegation so it works for dynamically added links
    document.addEventListener("click", function (e) {
      if (e.target.closest(".benefits-link")) {
        e.preventDefault();
        document
          .querySelector(".benefits-modal-overlay")
          ?.classList.add("show-modal");
      }
    });

    this.setProductModalEvents();
  },
  setProductModalEvents: function () {
    const openProductModal = (e) => {
      e.stopPropagation();
      e.preventDefault();
      const modalOverlay = e.currentTarget
        .closest(".grid-item")
        ?.querySelector(".product-modal-overlay");
      modalOverlay?.classList.add("show-modal");
      modalOverlay?.querySelector("product-popup")?.updateGallery();
    };

    document
      .querySelectorAll(".js-open-product-modal")
      .forEach(function (linkEl) {
        linkEl.removeEventListener("click", openProductModal);
        linkEl.addEventListener("click", openProductModal);
      });
  },

  // Move modals to #ProductModals container (outside .transition-body)
  // This fixes position:fixed being trapped by transform on .transition-body
  moveModalsToContainer: function () {
    const container = document.querySelector("#ProductModals");
    if (!container) return;

    // Move benefits-modal, gift-modal, gift-info-modal, subscribe-and-save overlays (single elements)
    const singleModalSelectors = [
      ".benefits-modal-overlay",
      ".gift-modal-overlay",
      ".gift-info-modal-overlay",
      ".subscribe-and-save-popup-container",
      ".ingredients-overlay",
    ];

    singleModalSelectors.forEach(function (selector) {
      const modal = document.querySelector(selector);
      if (modal && !modal.closest("#ProductModals")) {
        container.appendChild(modal);
      }
    });

    // Move ALL .ingredients-popup elements (there may be duplicates in the DOM)
    document.querySelectorAll(".ingredients-popup").forEach(function (popup) {
      if (!popup.closest("#ProductModals")) {
        container.appendChild(popup);
      }
    });
  },
};

document.addEventListener("DOMContentLoaded", function () {
  window.modal.init();
});
}
